<template>
  <div class="page">
    <div class="header">油站提供什么？</div>

    <div v-for="(preview, i) in previewList" :key="i">
      <div class="station_name" v-show="preview.gasCount || preview.gasDesc">共计<span>{{ preview.gasCount }}</span>个：{{ preview.gasDesc }}</div>
      <div class="discount_wrap">
        <div v-for="(item, index) in preview.discountList" :key="index" class="discount_item">
          <div>
            <span class="value">{{ item.discountRatio }}</span>
            <span>{{ item.discountType === 1 ? '%' : '元' }}</span>
          </div>
          <div class="name">{{ item.spuDesc }}营销优惠</div>
        </div>
      </div>
    </div>

    <div class="header" style="margin-top: 30px;">油站得到什么？</div>

    <div class="benefit_list">
      <div class="benefit_item">
        <div class="title">
          <img :src="benefitList.icon" alt="">
          <div>{{ benefitList.name }}</div>
        </div>
        <div class="benefit_content">
          <div v-for="(subItem, i) in benefitList.contentList" :key="i">
            <div class="sub_content">
              <span class="light">{{ i+1 }}. </span>
              <span v-html="subItem"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tips_name">报名须知</div>
    <div class="tips_list" v-for="(item, i) in tipsList" :key="i">{{ item }}</div>

    <div class="footer g-flex-c">
      <el-button type="primary" @click="handleSubmit">立即参与</el-button>
    </div>
  </div>
</template>
<script>
import { growthPlanDetail, growthPlanSignup } from '@/api/marketPromotion'
import { ACTIVITY_MAP, CONTENT_MAP, TIPS_MAP } from './config'

export default {
  data () {
    return {
      previewList: [],
      dataKey: null,
      benefitList: {}, // 油站得到什么？
      tipsList: [], // 参与门槛
      activityType: '', // 活动类型
    }
  },
  methods: {
    async getData () {
      const { code, result } = await growthPlanDetail({ activityType: this.activityType })
      if (code !== 200) return
      this.previewList = result.previewList
      this.dataKey = result.dataKey
    },
    async handleSubmit () {
      const { code } = await growthPlanSignup({ dataKey: this.dataKey, activityType: this.activityType })
      if (code === 200 || code === 1006) {
        code === 200 ? this.$message.success('报名成功') : this.$message.error('当前没有需要报名的活动')
        this.$router.push({
          path: '/promotion/centerShow'
        })
      } else if (code === 1007) {
        this.$confirm('当前信息有变更，请重新确认后再报名。是否更新信息？', '信息确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.getData()
        }).catch(() => {
        })
      }
    }
  },
  created () {
    const { origin } = this.$route.query
    this.benefitList = CONTENT_MAP[origin]
    this.tipsList = TIPS_MAP[origin]
    const item = ACTIVITY_MAP.find(item => item.name === origin)
    if (item) this.activityType = item.value
    this.getData()
  }
}
</script>
<style lang="less">
@import url('./style.less');
</style>
